<script setup lang="ts">
import { PhArrowRight, PhWarningDiamond } from "@phosphor-icons/vue"
import type { DashboardRecommendation } from "../utils/dashboard-types"
import DashboardCard from "./DashboardCard.vue"
import StatusBadge from "./StatusBadge.vue"

defineProps<{
  recommendation: DashboardRecommendation
}>()
</script>

<template>
  <DashboardCard :variant="recommendation.severity === 'high' ? 'warning' : 'dark'" dense>
    <div class="flex items-start justify-between gap-4">
      <div class="min-w-0">
        <div class="flex items-center gap-2">
          <PhWarningDiamond :size="18" class="text-(--dash-warning)" />
          <StatusBadge :status="recommendation.severity" />
        </div>
        <h2 class="mt-4 text-lg font-medium leading-tight text-(--dash-ink)">
          {{ recommendation.title }}
        </h2>
        <p class="mt-3 text-sm leading-5 text-(--dash-muted)">{{ recommendation.reason }}</p>
      </div>
      <span class="dashboard-mono shrink-0 text-xs text-(--dash-dim)">{{ recommendation.scope }}</span>
    </div>

    <div class="mt-5 grid gap-2 text-sm">
      <div class="flex items-start gap-2 text-(--dash-muted)">
        <span class="dashboard-label mt-1">Evidence</span>
        <span class="min-w-0">{{ recommendation.evidence }}</span>
      </div>
      <div class="flex items-start gap-2 text-(--dash-ink)">
        <PhArrowRight :size="15" class="mt-1 shrink-0" />
        <span class="min-w-0">{{ recommendation.nextAction }}</span>
      </div>
    </div>
  </DashboardCard>
</template>
